const ffPlan = (() => {
  const pageFamilyFree = (document.getElementById("pageFamilyFree") != null);
  if (pageFamilyFree) {


    let sW = window.innerWidth;

    let centeredSlides;
    let slidesPerView;
    let spaceBetween;

    if (sW > 750) {
      centeredSlides = false
      slidesPerView = 1.0
      spaceBetween = 40
    } else {
      centeredSlides = true
      slidesPerView = 1.3
      spaceBetween = 20
    }

    const swiper = new Swiper("#jsSwiperPlan", {
      loop: true,
      centeredSlides: centeredSlides,
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetween,
      speed: 800,
      navigation: {
        nextEl: ".swiper-btn-next",
        prevEl: ".swiper-btn-prev"
      }
    });

    let swiperCopy = document.getElementById("jsSwiperPlanCopy")
    let num = swiperCopy.querySelector('.js-num');
    let ttl = swiperCopy.querySelector('.js-ttl');
    let txt = swiperCopy.querySelector('.js-txt');
    swiper.on('slideChange', function () {
      if (swiper.realIndex == 0) {
        num.textContent = `#1`;
        ttl.textContent = `洋室1`;
        txt.textContent = `親子3人で寝ている主寝室。しばらくは同じ部屋で、成長とともに個室を使い分けて。そんな変化に合わせた住まいをライフステージごとに楽しんでいきたい。親子で「川の字」で寝られるなんて、こんな愛しい時間は今だけ！`;
      } else if (swiper.realIndex == 1) {
        num.textContent = `#2`;
        ttl.textContent = `BRICKS FREE`;
        txt.textContent = `家族皆で使えて、愛犬とも遊べて、趣味も楽しめる・・・そんな欲張りを叶える空間「BRICKS FREE」。どこに居ても何をしているか見えるオープンな空間のおかげで、娘が絵本を楽しんだり、愛犬と遊んだりしている自然な表情を楽しむことができるのも嬉しいポイント。`;
      } else if (swiper.realIndex == 2) {
        num.textContent = `#3`;
        ttl.textContent = `洋室2`;
        txt.textContent = `洋室2の一角はホビースペースに。音楽好きな夫の希望だったけど、夜は夫婦でお酒を飲みながらレコードに針を落とす時間が最高のひとときに。リビングと雰囲気を変えたしつらえは、空間のアクセントになっていい感じ。`;
      } else if (swiper.realIndex == 3) {
        num.textContent = `#4`;
        ttl.textContent = `Ⅱ型（2列型）キッチン`;
        txt.textContent = `作業スペースが広く、家事動線が抜群のキッチン。さらに、リビング・ダイニングと自由に行き来できることで毎日の家事タイムがテンションアップ。まさかの子供が自然と食事を運んだり片付けてくれるようになったのは嬉しい。`;
      }
    });

    let swiperBtn = document.getElementById("jsSwiperPlanBtn")
    let btn = swiperBtn.querySelectorAll('.btn');
    for (let i = 0; i < btn.length; i++){
      btn[i].addEventListener('click', () => {
        if(i == 0){
          swiper.slideToLoop(0)
        }
        if(i == 1){
          swiper.slideToLoop(1)
        }
        if(i == 2){
          swiper.slideToLoop(2)
        }
        if(i == 3){
          swiper.slideToLoop(3)
        }
      });
    }


  }
})();
export default ffPlan;